import { render, staticRenderFns } from "./TakeOverModal.vue?vue&type=template&id=4a8cbee6&scoped=true&"
import script from "./TakeOverModal.vue?vue&type=script&lang=js&"
export * from "./TakeOverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8cbee6",
  null
  
)

export default component.exports